"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _originalUrl = _interopRequireDefault(require("original-url"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Get the host for server-side calls.
 */
var _default = req => {
  if (!req) {
    throw new Error('A request object must be passed to establish the site config on the server.');
  }
  return (0, _originalUrl.default)(req).hostname;
};
exports.default = _default;